import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Popup, Icon} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Tabla from "../common/ManageTabla";
import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/es_ES';
//import "antd/dist/antd.css";
const dateFormat = 'DD/MM/YYYY';


const ModuloForm=({ id, color, archivos, form, onSave,onChange, tagCombo, 
                   contenidoCombo,contenidoComboTipo, ajaxCallInProgress, datos, 
                   infoActions, errors={}, strings, permisos, user,comboInstructor, fechas, fechas2, onBuscar, goBack,  test, close })=>{
    

	return (
        <Container>
         
        
        
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["titulo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["titulo"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.descripcion}>            
                              <label  >{strings?strings["descripcion"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["descripcion"]:""} 
                                    name="descripcion"
                                    onChange={onChange}
                                    value={datos.descripcion}
                                    icon='edit'/>
                            </Form.Field>
                                            
        
                             <Form.Field required>
                                <label  >{strings?strings["fechaInicioCurso"]:""}</label>  
                                <DatePicker bordered={false}
                                        value={datos.fechaInicio==null?"":dayjs(datos.fechaInicio, dateFormat)}
                                        onChange={(date, dateString)=>fechas(date, dateString)} 
                                        locale={locale} 
                                        size="large" 
                                        format={dateFormat} />
                             </Form.Field>

                                        
                            <Form.Field required>
                                <label  >{strings?strings["fechaFinCurso"]:""}</label>  
                                <DatePicker bordered={false}
                                        value={datos.fechaFin==null?"":dayjs(datos.fechaFin, dateFormat)}    
                                        onChange={(dates, dateStrings)=>fechas2(dates, dateStrings)} 
                                        locale={locale} 
                                        size="large" 
                                        format={dateFormat} />
                            
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.idsTags}>
                              <label  >{strings?strings["idsTags"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsTags"]:""} 
                                    name="idsTags"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsTags}
                                    options={tagCombo}/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                
                                    <Button  onClick={close}
										>{strings?strings["cerrar"]:""}</Button>
                                
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default ModuloForm;